import { create } from 'zustand';
import { api } from '../services/api';

export const useRecommendationsStore = create((set, get) => ({
  // Summary state
  summary: null,
  isLoadingSummary: false,

  // Chart state
  chartData: [],
  chartPeriod: '30days',
  isLoadingCharts: false,

  // Funnel state
  funnel: null,
  isLoadingFunnel: false,

  // Users list state
  users: [],
  usersTotal: 0,
  usersLimit: 20,
  usersOffset: 0,
  searchQuery: '',
  isLoadingUsers: false,

  // Top users state
  topUsers: [],
  topUsersTotal: 0,
  topUsersPage: 1,
  topUsersLimit: 20,
  isLoadingTopUsers: false,

  // Actions
  fetchSummary: async () => {
    set({ isLoadingSummary: true });
    try {
      const data = await api.getRecommendationsSummary();
      set({ summary: data, isLoadingSummary: false });
    } catch (error) {
      console.error('Failed to fetch recommendations summary:', error);
      set({ isLoadingSummary: false });
    }
  },

  fetchCharts: async (period = '30days') => {
    set({ isLoadingCharts: true, chartPeriod: period });
    try {
      const data = await api.getRecommendationsCharts(period);
      set({ chartData: data, isLoadingCharts: false });
    } catch (error) {
      console.error('Failed to fetch recommendations charts:', error);
      set({ isLoadingCharts: false });
    }
  },

  fetchFunnel: async () => {
    set({ isLoadingFunnel: true });
    try {
      const data = await api.getRecommendationsFunnel();
      set({ funnel: data, isLoadingFunnel: false });
    } catch (error) {
      console.error('Failed to fetch recommendations funnel:', error);
      set({ isLoadingFunnel: false });
    }
  },

  fetchUsers: async (params = {}) => {
    const {
      limit = get().usersLimit,
      offset = get().usersOffset,
      search = get().searchQuery
    } = params;

    set({ isLoadingUsers: true, usersLimit: limit, usersOffset: offset });

    try {
      const data = await api.getRecommendationsUsers({ limit, offset, search });
      set({
        users: data.users || [],
        usersTotal: data.total || 0,
        isLoadingUsers: false
      });
    } catch (error) {
      console.error('Failed to fetch recommendations users:', error);
      set({ isLoadingUsers: false });
    }
  },

  setSearchQuery: (search) => {
    set({ searchQuery: search, usersOffset: 0 });
    get().fetchUsers({ search, offset: 0 });
  },

  fetchTopUsers: async (page = 1, limit = 20) => {
    set({ isLoadingTopUsers: true, topUsersPage: page, topUsersLimit: limit });
    try {
      const data = await api.getRecommendationsTopUsers(limit);
      set({ topUsers: data, isLoadingTopUsers: false });
    } catch (error) {
      console.error('Failed to fetch top users:', error);
      set({ isLoadingTopUsers: false });
    }
  },

  // Fetch all data
  fetchAll: async () => {
    await Promise.all([
      get().fetchSummary(),
      get().fetchCharts(),
      get().fetchFunnel(),
      get().fetchUsers(),
      get().fetchTopUsers()
    ]);
  }
}));
